import React, { useEffect } from "react";
import "./staking.scss";
import { Accordion, Modal } from "react-bootstrap";
import { useState } from "react";
import Navbar from "../landing/header/Navbar";
import moment from "moment";
import axios from "axios";
import Environment from "../../utils/Environment";
import GetGemsBalance from "../../hooks/chinaFunction/getGemsBalance";
import GetGemsStaked from "../../hooks/chinaFunction/getGemsStakeAmount";
import StakeGems from "../../hooks/chinaFunction/stakeGems";

import UnStakeGems from "../../hooks/chinaFunction/unstakeGems";
import AllowanceGems from "../../hooks/chinaFunction/allowanceGems";

// import AllowanceLinkStake from "../../hooks/dataFetchers/AllowanceLink";

import ApproveGems from "../../hooks/chinaFunction/approveGems";

// import ApproveTpl1 from "../../hooks/dataFetchers/ApproveTpl1";
import GetGemsStakedIndex from "../../hooks/chinaFunction/getGemsStakedIndex";
import { toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import Loader from "../../hooks/loader";
import { useHistory } from "react-router-dom";
import CuurentRound from "../../hooks/chinaFunction/round";
import Footer from "../landing/Footer/Footer";
import { API_URL } from "../../utils/ApiUrl";

import { logDOM } from "@testing-library/react";
import useWeb3 from "../../hooks/useWeb3";
import { TOKENS } from "../../utils/Constants";
const Staking = () => {
  let round = localStorage.getItem("currentRunningRound");
  let countryBuyer = localStorage.getItem("country");
  const web3 = useWeb3();
  const { cuurentRound } = CuurentRound();
  const history = useHistory();
  const { account } = useWeb3React();
  const { GetGemsBal } = GetGemsBalance();
  const [token, setToken] = useState(TOKENS[0]);
  // const { balacefAccount } = BalacefAccount();
  const { getGemsStaked } = GetGemsStaked();
  const { stakeGems } = StakeGems();
  const { unstakeGems } = UnStakeGems();
  const { allowanceGems } = AllowanceGems();
  const { approveGems } = ApproveGems();
  // const { approveTpl1 } = ApproveTpl1();

  const { getGemsStakedIndex } = GetGemsStakedIndex();

  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [amount, setAmount] = useState(200);
  const [amountError, setAmountError] = useState("");
  const [walletError, setWalletError] = useState("");
  const [stakeIndex, setStakeIndux] = useState(null);
  const [stakeIndex1, setStakeIndux1] = useState(null);

  const [balance, setBalance] = useState(0);
  const [allowance, setAllowance] = useState(0);

  const [minStakeAmount, setMinStakeAmount] = useState(999999999999999);
  const [stakingGasFees, setStakingGasFees] = useState(0);
  const [stakedAmount, setStakedAmount] = useState(0);

  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakeEndTime1, setStakeEndTime1] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  const [stakingData1, setStakingData1] = useState({});
  const [tagImge, setTagImge] = useState("/assets/eth-icon.svg");
  const [mainTag, setMainTag] = useState("ETH");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(10); // Define how many items to show per page
  const [orderBy, setOrderBy] = useState("blockTimestamp");
  const [orderDirection, setOrderDirection] = useState("asc");
  const [show1, setShow1] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);

  const [show2, setShow2] = useState(false);

  const handleClose1 = () => {
    setShow2(false);
    window.location.assign("/buy");
  };
  const handleShow1 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => {
    setShow3(false);
    window.location.assign("/buy");
  };


  // async function getPrice(token) {
  //   try {
  //     const response = await fetch(`${Api_Url}/users/prices?token=${token}`);
  //     const data = await response.json();

  //     // Assuming the API returns something like { price: 25.43 }
  //     return parseFloat(data.data.data)?.toFixed(4);
  //   } catch (error) {
  //     console.error("Error fetching price:", error);
  //     return null;
  //   }
  // }


  // const fetchStakingData = async () => {
  //     setLoader1(true)
  //     try {
  //         const response = await axios.post(
  //             "https://api.studio.thegraph.com/query/63987/staking-gems-testnet/12",
  //             {
  //                 query: `
  //             query MyQuery($staker: String, $isClaimed: Boolean,) {
  //               stakeds(where: {staker: $staker}, isClaimed: $isClaimed,) {

  //                 blockTimestamp
  //                 stakeEndTime
  //                 isClaimed
  //               }
  //             }`,
  //                 variables: {
  //                     staker: account,
  //                 },
  //             },
  //             {
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                 },
  //             }
  //         );

  //         const resData = response.data.data.stakeds;
  //         if(resData.length>0){
  //         console.log(resData[0], 'resData');
  //         // setStakeIndux(parseInt(resData[0]?.stakerStakeIndex))
  //         setStakingData(resData);
  //         const currentTime = moment();
  //         const endTimeStampInSeconds = parseInt(
  //             resData[resData?.length - 1]?.stakeEndTime
  //         );
  //         const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
  //         if (!endTimeStamp.isValid()) {
  //             setStakeEndTime(currentTime);
  //         } else {
  //             setStakeEndTime(endTimeStamp);
  //         }
  //         setLoader1(false)
  //     }
  //     } catch (error) {
  //         console.error("Error fetching staking data: ", error);
  //         setLoader1(false)
  //     }
  // };


  const fetchStakingData = async () => {
    setLoader1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {isClaimed: false, staker: "${account}"}) {
          stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.gemsLockingGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        const resData = response.data.data.stakeds;
        if (resData.length > 0) {
          setStakeIndux(parseInt(resData[0]?.stakerStakeIndex));
          setStakingData(resData);
          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(
            resData[resData?.length - 1]?.stakeEndTime
          );
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
          if (!endTimeStamp.isValid()) {
            setStakeEndTime(currentTime);
          } else {
            setStakeEndTime(endTimeStamp);
          }
        }
        setLoader1(false);
      })
      .catch(function (error) {
        setLoader1(false);
        console.log(error, "error");
      });
  };
  const fetchStakingData1 = async (useV2 = false) => {
    setLoader1(true);

    const graphURL = useV2
      ? Environment.gemSubscriptionMultiple
      : Environment.gemsSubscribeGrap;

    const data = JSON.stringify({
      query: `query MyQuery {
        subscribeds(where: {by: "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
          blockTimestamp
          blockNumber
          amountPurchased
          by
          endTime
          id
          tokenPrice
          transactionHash
        }
      }`,
      variables: {},
    });

    const config = {
      method: "post",
      url: graphURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      const response = await axios(config);
      const resData = response.data.data.subscribeds;
      if ((!resData || resData.length === 0) && !useV2) {
        return fetchStakingData1(true);
      }
      if (resData.length > 0) {
        const currentTime = moment();
        const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
        const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds

        if (!endTimeStamp.isValid() || currentTime.isAfter(endTimeStamp)) {
          if (!useV2) {
            // Re-fetch with alternate graph if not already using it
            return fetchStakingData1(true);
          } else {
            setStakeEndTime1(currentTime);
          }
        } else {
          setStakeEndTime1(endTimeStamp);
        }

        setStakingData1(resData[0]);
      }

      setLoader1(false);
    } catch (error) {
      setLoader1(false);
      console.log(error, "error");
    }
  };

  const unstake = async (index) => {
    setLoader(true);
    // console.log([index], '[index]');
    try {
      const gas = await unstakeGems(account, index);
      if (gas) {
        // handleShow1();
        setLoader(false);
        getGemsStakedAmount();
        setShow3(true);
        setTimeout(() => {
          fetchStakingData();
          fetchStakingData1();
        }, 5000);
      }
    } catch (e) {
      setLoader(false);
      console.error(e);
      toast.error(e?.message);
    }
  };


  // console.log("valuess))))))))", balanceEth, amount, amount / EthPrice)

  // const Stake = async () => {
  //   setLoader(true);
  //   try {
  //     let config = {
  //       method: "post",
  //       url: `${API_URL}users/buy-premium-subscription`,
  //       data: {

  //         // gemsAddress: Environment.gems,
  //         walletAddress: account,
  //         country: countryBuyer,

  //         // walletAddress: account.toLocaleLowerCase(),
  //         // country: countryBuyer,
  //         // type: "NODE",
  //         // tokenSelected: selectedToken?.mainTag,
  //       },
  //     };
  //     let postApiRes = await axios(config)
  //       .then(function (response) {
  //         return response?.data?.data;
  //       })
  //       .catch(function (error) {
  //         console.log("error here is")
  //         setLoader(false);
  //         toast.error(error?.response?.data.message);
  //         // setLoarder(false);
  //       });
  //     if (postApiRes) {
  //       if (balance >= amount / gemsPrice) {
  //         if (allowance >= amount / gemsPrice) {
  //           try {
  //             const gas = await stakeGems(postApiRes);

  //             if (gas) {
  //               // stakeAPI();
  //               handleClose();
  //               handleShow1();
  //               setLoader(false);
  //               getGemsStakedAmount();
  //               getGemsBalanceFunc();
  //               setTimeout(() => {
  //                 fetchStakingData();
  //               }, 5000);

  //               // setStakingGasFees(gas);
  //               // handleShow();
  //             }
  //           } catch (e) {
  //             setLoader(false);
  //             console.error(e);
  //             toast.error(e?.message);
  //           }
  //         } else {
  //           try {
  //             setLoader(true);

  //             const approve = await approveGems(account);
  //             if (approve) {
  //               getAllowance();
  //               getGemsBalanceFunc();
  //               if (balance >= amount / gemsPrice) {
  //                 try {
  //                   const gas = await stakeGems(postApiRes);
  //                   if (gas) {
  //                     // stakeAPI();
  //                     handleClose();
  //                     handleShow1();
  //                     setLoader(false);
  //                     getGemsStakedAmount();
  //                     getGemsBalanceFunc();

  //                     setTimeout(() => {
  //                       fetchStakingData();
  //                     }, 5000);

  //                     // setStakingGasFees(gas);
  //                     // handleShow();
  //                   }
  //                 } catch (e) {
  //                   setLoader(false);
  //                   console.error(e);
  //                   toast.error(e?.message);
  //                 }
  //               } else {
  //                 // handleShow2();
  //                 setLoader(false);
  //                 toast.error("Not Enough GEMS Balance");
  //                 //   setTimeout(() => {
  //                 //     setWalletError("Not Enough GEMS Balance");
  //                 //   }, 5000);
  //               }
  //             }
  //           } catch (e) {
  //             setLoader(false);
  //             console.error(e);
  //             toast.error(e?.message);
  //           }
  //         }
  //       } else {
  //         // handleShow2();
  //         setLoader(false);
  //         toast.error("Not Enough GEMS Balance");
  //         // setWalletError("Not Enough GEMS Balance");
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err, "in stake ");
  //     setLoader(false);
  //   }
  // };

  // console.log("asdasdasdasdasd", allowanceUni)

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked !== null || staked !== undefined) {
      setStakedAmount(staked);
    }
  };


  //  const StakeIndec=async()=>{
  //     const bal = await getGemsStakedIndex(account);
  //     console.log(bal, 'bal');
  //     if (bal !== null || bal !== undefined) {
  //         setStakeIndux(parseInt(bal)-1)
  //     }
  //  }

  useEffect(() => {
    if (account) {
      // StakeIndec()
      fetchStakingData();
      fetchStakingData1();
      getGemsStakedAmount();
    }
  }, [account]);
  // console.log(stakingData?.length, "stakingData?.length ", stakedAmount);

  const getGemsBalanceFunc = async (token) => {
    const { tokenAddress, decimals, NAME } = token;

    try {
      let bal;

      if (NAME === "ETH") {
        const balanceInWei = await web3.eth.getBalance(account);
        bal = web3.utils.fromWei(balanceInWei, 'ether');
        bal = parseFloat(bal).toFixed(4);
      } else {
        bal = await GetGemsBal(account, tokenAddress, decimals);
      }

      if (bal !== null && bal !== undefined) {
        setBalance(bal);
        return bal;
      } else {
        setBalance(0);
        return 0;
      }

    } catch (error) {
      console.error("Error getting token balance:", error);
      setBalance(0);
      return 0;
    }
  };

  const getAllowance = async (token) => {
    if (token?.NAME === 'ETH') {
      setAllowance(0);
      return 0
    }
    const all = await allowanceGems(account, token?.tokenAddress, token?.decimals);
    if (all !== null || all !== undefined) {
      setAllowance(all);
      return all;
    } else {
      return 0
    }
  };

  async function getPrice(token) {
    try {
      let tokenName
      if (token === 'WBTC') {
        tokenName = 'BTC'
      } else {
        tokenName = token
      }
      const response = await fetch(`${API_URL}users/prices?token=${tokenName}`);
      const data = await response.json();

      // Assuming the API returns something like { price: 25.43 }
      return parseFloat(data.data.data)?.toFixed(7);
    } catch (error) {
      console.error("Error fetching price:", error);
      return null;
    }
  }

  const Stake = async () => {
    if (!account) {
      toast.info('Please Connect Your Wallet');
      return;
    }
    console.log("stake func");
    setLoader(true);
    let tokenBalance = await getGemsBalanceFunc(token);
    const token_Price = await getPrice(token?.NAME);
    let token_allowance = await getAllowance(token);
    console.log("values454545", tokenBalance, amount, token_Price)

    console.log(tokenBalance, token_Price, token_allowance, token_allowance, 'tokenBalance');

    if (account) {
      console.log("stake func account yes");

      if (account) {
        let config = {
          method: "post",
          url: `${API_URL}users/buy-premium-subscription`,
          data: {
            tokenSelected: token?.NAME,
            walletAddress: account,
            country: countryBuyer,

            // walletAddress: account.toLocaleLowerCase(),
            // country: countryBuyer,
            // type: "NODE",
            // tokenSelected: selectedToken?.mainTag,
          },
        };
        console.log("stake func api config");
        let postApiRes = await axios(config)
          .then(function (response) {
            return response?.data?.data;
          })
          .catch(function (error) {
            setLoader(false);
            console.error("API Error:", error);
            toast.error(error?.response?.data?.message || "API request failed");
            return null;
          });
        if (postApiRes) {
          // console.log(tokenBalance, amount, token_Price, amount / token_Price, 'amount / token_Priceamount / token_Price');
          if (tokenBalance >= amount / token_Price) {
            if (token?.NAME === 'ETH' || token_allowance >= amount / token_Price) {
              // console.log("LLOWNCEGEHRE COME")
              try {
                setLoader(true);
                let subAmount = amount / token_Price;
                // console.log(subAmount, 'amount / token_Priceamount / token_Price');
                // Add 2 percent to subAmount
                const increasePercentage = 0.02;

                subAmount = subAmount * (1 + increasePercentage);
                let increasedAmount = subAmount * 10 ** token?.decimals;
                // console.log(increasedAmount, 'amount / token_Priceamount / token_Price');


                const gas = await stakeGems(postApiRes, account, token, increasedAmount);
                console.log("gas: ", gas);

                if (gas) {
                  // stakeAPI(gas?.transactionHash, gas?.timestamp);
                  handleClose();
                  handleShow1();
                  setLoader(false);
                  getGemsStakedAmount();
                  getGemsBalanceFunc();
                  setTimeout(() => {
                    fetchStakingData();
                  }, 5000);

                  // setStakingGasFees(gas);
                  // handleShow();
                }
              } catch (e) {
                setLoader(false);
                console.error(e);
                toast.error(e?.message);
              }
            } else {
              try {
                setLoader(true);
                // console.log(tokenBalance >= amount / token_Price, 'amount / token_Price*********');
                // amount / token_Price       
                const approve = await approveGems(account, tokenBalance, token?.tokenAddress, token?.decimals);
                if (approve) {
                  getAllowance(token);
                  let tokenBalance = await getGemsBalanceFunc(token);
                  if (tokenBalance >= amount / token_Price) {
                    try {
                      let subAmount = amount / token_Price;
                      const gas = await stakeGems(postApiRes, account, token, subAmount);
                      console.log("gas: ", gas);
                      if (gas) {
                        // stakeAPI(gas?.transactionHash, gas?.timestamp);
                        handleClose();
                        handleShow1();
                        setLoader(false);
                        getGemsStakedAmount();
                        getGemsBalanceFunc();
                        setTimeout(() => {
                          fetchStakingData();
                        }, 5000);

                        // setStakingGasFees(gas);
                        // handleShow();
                      }
                    } catch (e) {
                      setLoader(false);
                      console.error(e);
                      toast.error(e?.message);
                    }
                  } else {
                    // handleShow2();
                    setLoader(false);

                    toast.error(`Not Enough ${token?.NAME} Balance`);
                  }
                }
              } catch (e) {
                setLoader(false);
                console.error(e);
                toast.error(e?.message);
              }
            }
          } else {
            setLoader(false);
            // handleShow2();
            toast.error(`Not Enough ${token?.NAME} Balance`);
          }
        }
      } else {
        toast.error("Incorrect Wallet!");
        setLoader(false);
      }
    } else {
      // setWalletError("Connect Wallet!");
      handleClose();
      toast.error("Please Connect Your Wallet First");
      setLoader(false);
    }
  };



  return (
    <>
      {loader1 && <Loader />}
      {loader && (
        <Loader text={"Please wait, your transaction is in process"} />
      )}
      <Navbar show={show} setShow={setShow} />

      <section className="main-staking">
        <div className="upperbanner">
          <div className="custom-container">
            <h6 className="staketoppara">Gems Premium</h6>
            <h4 className="stakemainhead">
              Get upto {round == 1 ? "20" : "7"}% discount on{" "}
              <span className="newertext">your purchases</span>
            </h4>
            <p>
              Get 20% discount in the first round of every sale and 7% discount
              in every following round!
            </p>
          </div>
        </div>
        <div className="lowerbanner">
          <div className="custom-container">
            <div className="newboxes-twice">
              <div className="single-box">
                <div className="upper-content">
                  <h6>basic</h6>
                  <h4>
                    <span>$0</span>
                  </h4>
                </div>
                <div className="bottom-content">
                  <div className="inner-single singlearea">
                    <div
                      className="text"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <p style={{ color: "#329879", fontFamily: "hsemibold" }}>Launchpad</p>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Private sale first round discount</p>
                    </div>
                    <div className="text">
                      <span className="redtext">0%</span>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Private sale additional rounds discount</p>
                    </div>
                    <div className="text">
                      <span className="redtext">0%</span>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>
                        Miner Safeguard <span className="orange-text">New</span>
                      </p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>
                        Credit Refund <span className="orange-text">New</span>
                      </p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single singlearea">
                    <div
                      className="text"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <p style={{ color: "#329879", fontFamily: "hsemibold" }}>Trade</p>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Lower trade fees</p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p> Sign-in reward</p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Affiliate Program</p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                {stakingData?.length === 0 && (stakeEndTime1?.length === 0 || moment().isAfter(stakeEndTime1)) && (
                  <a className="btn-plan">
                    CURRENT PLAN
                  </a>
                )}

              </div>
              <div className="main-bottom-ahead">
                <div className="single-box activee">
                  <div className="upper-content">
                    <div className="d-flex justify-content-between align-item-center">
                      <h6 style={{ color: "#E88F35" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <path
                            d="M20.5834 3.25H5.41675L2.16675 9.75L13.0001 22.75L23.8334 9.75L20.5834 3.25ZM10.4217 8.66667L12.0467 5.41667H13.9534L15.5784 8.66667H10.4217ZM11.9167 10.8333V18.07L5.89341 10.8333H11.9167ZM14.0834 10.8333H20.1067L14.0834 18.07V10.8333ZM20.8651 8.66667H17.9942L16.3692 5.41667H19.2401L20.8651 8.66667ZM6.76008 5.41667H9.63092L8.00591 8.66667H5.13508L6.76008 5.41667Z"
                            fill="#E89735"
                          />
                        </svg>
                        Gems Premium
                      </h6>
                      {/* {stakingData?.length > 0 &&
                        moment().isAfter(stakeEndTime) ? (
                        <p
                          className="cdhbdybydbcy"
                          style={{ color: "#FF4A4A" }}
                        >
                          Plan expired on{" "}
                          {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : null} */}
                    </div>
                    {/* <h4>
                      <span>$200</span>{" "}
                      <div className="rightstyle">
                        <span className="yeartext">/year </span>{" "}
                        <span className="paidtext">Paid in ${token?.NAME}</span>
                      </div>
                    </h4> */}
                    <h3 className="mainheading">
                      <span className="cutfour">$400</span>
                      $200
                      <div className="righthead">
                        <span className="limited">Limited Time Offer</span>
                        <p className="yearpara">/year </p>
                      </div>
                    </h3>
                  </div>
                  <div className="bottom-content">
                    <div className="inner-single singlearea">
                      <div
                        className="text"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <p style={{ color: "#329879", fontFamily: "hsemibold" }}>
                          Launchpad
                        </p>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Private sale first round discount</p>
                      </div>
                      <div className="text">
                        <span className="greentext">20%</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Private sale additional rounds discount</p>
                      </div>
                      <div className="text">
                        <span className="greentext">7%</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>
                          Miner Safeguard{" "}
                          <span className="orange-text">New</span>
                        </p>
                      </div>
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M14.5 6.12139L14.5 0.5L5.72892 9.04331L0.5 5.44118L0.5 10.6526L5.72892 14.5L14.5 6.12139Z"
                            fill="#329879"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>
                          Credit Refund <span className="orange-text">New</span>
                        </p>
                      </div>
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M14.5 6.12139L14.5 0.5L5.72892 9.04331L0.5 5.44118L0.5 10.6526L5.72892 14.5L14.5 6.12139Z"
                            fill="#329879"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="inner-single singlearea">
                      <div
                        className="text"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <p style={{ color: "#329879", fontFamily: "hsemibold" }}>Trade</p>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Lower trade fees</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p> Sign-in reward</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Affiliate Program</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown dropdownstakingtoken">
                    <button class="dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-expanded="false">
                      <div className="leftdrop">
                        Pay With <img src={`/assets/${token.tokenImg}.svg`} alt="img" className="img-fluid" /> <span>{token?.NAME}</span>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 15 7" fill="none">
                        <path d="M0.535156 0L0.535157 2.97056L7.76848 7L7.76848 4.02943L0.535156 0Z" fill="#02171D" />
                        <path d="M15 0.00012207L15 2.97068L7.76667 7.00012L7.76667 4.02955L15 0.00012207Z" fill="#02171D" />
                      </svg>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      {TOKENS.map((token) => (
                        <li key={token.tokenImg}>
                          <a
                            className="dropdown-item"

                            onClick={() => setToken(token)}
                          >
                            <img
                              src={`/assets/${token.tokenImg}.svg`}
                              alt={token.NAME}
                              className="img-fluid"
                            />
                            {token.NAME}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>


                  {account ? (
                    <>
                      {!stakingData1 ? (
                        <a
                          className="btn-plan activee"
                          onClick={() => {
                            handleShow();
                          }}
                        >
                          Get Gems Premium
                        </a>
                      ) : (stakingData?.length > 0 &&
                        moment().isBefore(stakeEndTime)) ||
                        moment().isAfter(stakeEndTime) ? (
                        <a
                          className="btn-plan activee disabled"
                          onClick={() => {
                            handleShow();
                          }}
                        >
                          Get Gems Premium
                        </a>
                      ) : stakingData?.length > 0 &&
                        moment().isAfter(stakeEndTime) ? (
                        ""
                      ) : (
                        // <div className="twice-btns">
                        //   <a
                        //     className="withdraw-gems"
                        //     onClick={() => {
                        //       unstake(stakeIndex);
                        //     }}
                        //   >
                        //     Withdraw Gems
                        //   </a>
                        //   {/* <a
                        //     className="upgrade-gems"
                        //     onClick={() => {
                        //       handleShow();
                        //     }}
                        //   >
                        //     Subscribe
                        //   </a> */}
                        // </div>
                        <>
                          {stakingData && moment().isBefore(stakeEndTime1) ? (
                            <a
                              className="btn-plan"
                              style={{ justifyContent: "space-between" }}
                            >
                              <h6 style={{ color: "#329879" }}>CURRENT PLAN</h6>
                              <p>
                                expires on{" "}
                                {moment(stakeEndTime1)?.format("DD/MM/YY")}
                              </p>
                            </a>
                          ) : (
                            <a
                              className="btn-plan activee"
                              onClick={() => {
                                handleShow();
                              }}
                            >
                              Get Gems Premium
                            </a>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <a
                      onClick={() => setShow(true)}
                      className="btn-plan activee"
                    >
                      Connect Wallet
                    </a>
                  )}
                  {account &&
                    stakingData?.length > 0 &&
                    stakedAmount >= 5555 && (
                      <Accordion
                        defaultActiveKey="0"
                        className="withdrawaccordion"
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              viewBox="0 0 26 26"
                              fill="none"
                            >
                              <path
                                d="M20.5832 3.25H5.4165L2.1665 9.75L12.9998 22.75L23.8332 9.75L20.5832 3.25ZM10.4215 8.66667L12.0465 5.41667H13.9532L15.5782 8.66667H10.4215ZM11.9165 10.8333V18.07L5.89317 10.8333H11.9165ZM14.0832 10.8333H20.1065L14.0832 18.07V10.8333ZM20.8648 8.66667H17.994L16.369 5.41667H19.2398L20.8648 8.66667ZM6.75984 5.41667H9.63067L8.00567 8.66667H5.13484L6.75984 5.41667Z"
                                fill="#E89735"
                              />
                            </svg>
                            You are already subscribed to Gems Premium
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="accpara">
                              You will continue to enjoy your Gems Premium
                              benefits as long as your GEMS remain locked.
                            </p>
                            <p className="accpara mb-0">
                              If you choose to withdraw your locked tokens, your
                              Gems Premium benefits will be{" "}
                              <span className="bolder">canceled</span>, and you
                              can{" "}
                              <span className="bolder">
                                resubscribe at a rate of $200 per year.
                              </span>
                            </p>
                            {/* <button
                         className="dullbtn"
                       >
                         Withdraw 18,000 GEMS
                       </button> */}
                            {moment().isAfter(stakeEndTime) && (
                              <button
                                className="withdrawbtn"
                                onClick={() => {
                                  unstake(stakeIndex);
                                }}
                              >
                                Withdraw {stakedAmount?.toLocaleString()} GEMS
                              </button>
                            )}

                            {moment().isBefore(stakeEndTime) && (
                              <p className="lastparaacc">
                                Current Plan expires on{" "}
                                {moment(stakeEndTime)?.format("DD/MM/YY")}
                              </p>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    )}
                  {/* <a href="#" className="btn-plan" style={{ flexDirection: "column" }}>
                                        <h6>CURRENT PLAN</h6>
                                        <p>expires on 6/07/24</p>
                                    </a> */}
                  {/* <div className="twice-btns">
                                        <a href="#" className="withdraw-gems">
                                            Withdraw Gems
                                        </a>
                                        <a href="#" className="upgrade-gems">
                                            upgrade Again
                                        </a>
                                    </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      <Modal
        className="stakingmodal premiumstake-modal newmodalbackdrop"
        show={show1}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Get Gems Premium</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\premium\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\premium-icon1.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                Are you sure you want to <br />
                get Gems Premium?
              </h5>
              <p>
                You will be paying $200 in ${token?.NAME} to enjoy <br /> 1 year of
                discounted purchases.
              </p>
            </div>
            <div className="d-flex justify-content-center mb-4">
              {/* <p className="text-danger ">{walletError}</p> */}
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClose();
                }}
                className="cancelbtn"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  Stake();
                }}
                className="confirmbtn"
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal newmodalbackdrop"
        show={show2}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
            >
              <path
                d="M40 77.8947C60.9286 77.8947 77.8947 60.9286 77.8947 40C77.8947 19.0713 60.9286 2.10522 40 2.10522C19.0713 2.10522 2.10522 19.0713 2.10522 40C2.10522 60.9286 19.0713 77.8947 40 77.8947Z"
                fill="#329879"
              />
              <path
                d="M36.1262 54.3997C35.5788 54.3997 35.0315 54.1892 34.6525 53.7681L22.9473 42.0629C22.1051 41.2208 22.1051 39.9155 22.9473 39.0734C23.7894 38.2313 25.0946 38.2313 25.9367 39.0734L35.9999 49.1366L54.0209 26.3997C54.7367 25.4734 56.0841 25.3471 56.9683 26.0629C57.8946 26.7787 58.0209 28.126 57.3051 29.0102L37.8104 53.5997C37.4315 54.0629 36.8841 54.3576 36.2946 54.3997C36.2104 54.3997 36.1683 54.3997 36.1262 54.3997Z"
                fill="#E2E9EC"
              />
            </svg>
            <h6 className="successhead">Successfully Subscribed</h6>
            <p className="succesaspara">
              You have successfully subscribed to <br /> Gems Premium
            </p>
            <button
              className="greybtn w-100"
              onClick={() => {
                handleClose1();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal newmodalbackdrop"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
            >
              <path
                d="M40 77.8947C60.9286 77.8947 77.8947 60.9286 77.8947 40C77.8947 19.0713 60.9286 2.10522 40 2.10522C19.0713 2.10522 2.10522 19.0713 2.10522 40C2.10522 60.9286 19.0713 77.8947 40 77.8947Z"
                fill="#329879"
              />
              <path
                d="M36.1262 54.3997C35.5788 54.3997 35.0315 54.1892 34.6525 53.7681L22.9473 42.0629C22.1051 41.2208 22.1051 39.9155 22.9473 39.0734C23.7894 38.2313 25.0946 38.2313 25.9367 39.0734L35.9999 49.1366L54.0209 26.3997C54.7367 25.4734 56.0841 25.3471 56.9683 26.0629C57.8946 26.7787 58.0209 28.126 57.3051 29.0102L37.8104 53.5997C37.4315 54.0629 36.8841 54.3576 36.2946 54.3997C36.2104 54.3997 36.1683 54.3997 36.1262 54.3997Z"
                fill="#E2E9EC"
              />
            </svg>
            <h6 className="successhead">
              {stakedAmount?.toLocaleString()} Gems Unstaked
            </h6>
            <p className="succesaspara">Please check your wallet for details</p>
            <button
              className="greybtn w-100"
              onClick={() => {
                handleClose3();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Staking;
